document.addEventListener('DOMContentLoaded', function() {
  function disableVideoAutoplay() {
    const videos = document.querySelectorAll('.instant-video-fill__video');
    videos.forEach(function(video) {
      video.removeAttribute('autoplay');
      video.removeAttribute('loop');
      video.loop = false;
      video.autoplay = false;
      video.pause();
      video.currentTime = 0;
    });
    const wrappers = document.querySelectorAll('.instant-video-fill__wrapper');
    wrappers.forEach(function(wrapper) {
      wrapper.setAttribute('data-paused', 'true');
    });
  }
  disableVideoAutoplay();
  setTimeout(disableVideoAutoplay, 500);
  setTimeout(disableVideoAutoplay, 1000);
});

// Inject CSS
const ppStyle = document.createElement('style');
ppStyle.textContent = `
  #swym-atw-button-container {
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  #swym-atw-button-container.pp-swym-ready {
    visibility: visible;
    opacity: 1;
  }
  .pp-form-grid {
    display: grid;
    grid-template-columns: 100px 350px;
    gap: 10px;
    align-items: center;
  }
  .pp-buynow-row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 10px;
  }
  .pp-buynow-row .shopify-payment-button {
    flex: 1;
  }
  .pp-buynow-row #swym-atw-button-container,
  .pp-buynow-row #swym-custom-pdp-button {
    flex-shrink: 0;
    width: auto !important;
  }
  @media screen and (max-width: 768px) {
    .pp-form-grid {
    display: -webkit-grid !important;
    display: grid !important;
    -webkit-grid-template-columns: 110px 1fr !important;
    grid-template-columns: 110px 1fr !important;
    max-width: 100% !important;
  }
  
  .pp-form-grid .product-form__quantity {
    width: 110px !important;
    min-width: 110px !important;
    max-width: 110px !important;
  }
  
  .pp-form-grid .product-form__submit {
    width: 100% !important;
    min-width: 0 !important;
    flex: 1 !important;
  }

  .pp-buynow-row {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
  }
  .pp-buynow-row .shopify-payment-button {
    flex: 1;
    min-width: 0;
  }
  .pp-buynow-row .shopify-payment-button__button {
    width: 100% !important;
  }
  .pp-buynow-row #swym-custom-pdp-button,
  .pp-buynow-row .shopify-block {
    flex-shrink: 0;
    width: auto !important;
  }

  .pp-buynow-row .swym-icon {
    width: 30px !important;
    height: 30px !important;
  }
  }
`;
document.head.appendChild(ppStyle);

function fixProductFormLayout() {
  const buttons = document.querySelector('.product-form__buttons');
  if (!buttons) return;
  if (!buttons.querySelector('.pp-form-grid')) {
    const qty = buttons.querySelector('.product-form__quantity');
    const submit = buttons.querySelector('.product-form__submit');
    if (!qty || !submit) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'pp-form-grid';
    buttons.insertBefore(wrapper, qty);
    wrapper.appendChild(qty);
    wrapper.appendChild(submit);
  }

  if (!buttons.querySelector('.pp-buynow-row')) {
    const payBtn = buttons.querySelector('.shopify-payment-button');
    if (!payBtn) return;

    const row = document.createElement('div');
    row.className = 'pp-buynow-row';
    buttons.insertBefore(row, payBtn);
    row.appendChild(payBtn);
  }
}

function fixSwymPosition() {
  const buttons = document.querySelector('.product-form__buttons');
  const row = buttons?.querySelector('.pp-buynow-row');

  const swym = document.querySelector('#swym-atw-button-container') ||
               document.querySelector('#swym-custom-pdp-button')?.closest('.shopify-block');

  if (!row || !swym) return;

  row.appendChild(swym);
  swym.style.width = 'auto';
  swym.classList.add('pp-swym-ready');
}

fixProductFormLayout();
setTimeout(fixProductFormLayout, 300);
setTimeout(fixProductFormLayout, 800);

setTimeout(fixSwymPosition, 1000);
setTimeout(fixSwymPosition, 2000);
setTimeout(fixSwymPosition, 3000);